module.exports = __webpack_public_path__ + "static/media/marina.e137511f.png";